module.exports = __webpack_public_path__ + "static/img/team-build-1.0da25c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/team-build-1.png
// module id = m5gf
// module chunks = 1